import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CustomerFileDrop from './CustomerFileDrop';
function CustomerFileDropEntry(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(CustomerFileDrop, Object.assign({}, props))));
}
export default CustomerFileDropEntry;
